import React, {useState, useEffect} from 'react';
import Row from "olive-react-myoneui/lib/Row";
import Col from "olive-react-myoneui/lib/Col";
import Button from "olive-react-myoneui/lib/Button";
import BreadCrumbs from '../BreadCrumbs';
import { calendarsIcon, closeIcon, filterIcon, homeIcon, leftArrowLong, searchIcon, liveIcon, noTestData } from "../../../constants/icons";
import { FormControl } from 'olive-react-myoneui';
import MykPagination from '../MykPagination';
import SampleImage from "../../../../assets/img/sample2.jpg";
import SampleImage2 from "../../../../assets/img/sample2.jpg";
import CardEvent from "./CardEvent";
import EventFilter from "./EventsFilter";
import EventCalendar from '../event-calendar/EventCalendar';
import { getEnrolledEvents } from '../../../../api/afterLogin/events';
import { useSelector } from 'react-redux';
import { convertISOToReadable } from "../../../../helpers/datetime_helper";
import { format, parseISO } from "date-fns";
import { MyEventCalendar } from 'mykademy-learner-student-dashboard';
import { encode } from 'js-base64';
import { EventItemLoader } from '../../Loader';
import { imageSrc, filterUrl } from '../../../../helpers/url_helper';
import NoItems from '../courses/NoItems';
import Error403 from '../../../../modules/Error403';
import { checkDisabledSp } from '../../../../helpers/permission_helper';
import { decryptData } from '../../../../helpers/crypto_helper';

const Events = ({ className }) => {
    const adminData = useSelector((state) => state.admin);
    const configData = useSelector((state) => state.config);
    const contentFilterData = useSelector((state) => state.contentFilter);
    const paths = useSelector((state) => state.user.paths);
    const [filterSlide, setFilterSlide] = useState();
    const [searchSlide, setSearchSlide] = useState();
    const [searchQuery, setSearchQuery] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const [abortController, setAbortController] = useState(null);
    const [scrollPosition, setScrollPosition] = useState(0);
    const [data, setData] = useState('');
    const [keywords, setKeywords] = useState('');
    const [enrolledEvents, setEnrolledEvents] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [notFound, setNotFound] = useState(false);

    // CALENDER
    let origin      = window.location.pathname;
    const myArray   = origin.split("/");
   
    const authToken = configData.eventAuthToken;
    const spuid     = (myArray[1] == "student-dashboard") ? "mykademy" : myArray[1];
    const idp       = configData.idp;
    const secret    = decryptData(adminData.secret);
    const accountId = adminData.account_id;
    const timezone  = adminData.us_timezone;
    const uuid      = adminData.us_uid;
    const language  = adminData.language;
    const defaultImg= paths?.default_event;

    /* ACCESS CHECK */
    const products  = adminData.products;
    const userSpEnabled = adminData?.user_sp_enabled;
    const [noAccess, setNoAccess] = useState(checkDisabledSp('tms', products, userSpEnabled));

    const handleFilterSlide = () => {
        const body = document.body;

        if (filterSlide) {
            body.classList.remove('switched-filter-on');
            window.scrollTo(0, scrollPosition);
        } else {
            setScrollPosition(window.scrollY);
            body.classList.add('switched-filter-on');
            window.scrollTo(0, 0);
        }

        setFilterSlide(!filterSlide);
    }

    const handleCourseSearchSlide = () => {
        const body = document.body;
    
        if (searchSlide) {
          body.classList.remove('switched-search-on');
          window.scrollTo(0, scrollPosition);
        } else {
          setScrollPosition(window.scrollY);
          body.classList.add('switched-search-on');
          document.querySelector('.myk__stu-searchbar input[aria-label="Search"]').focus();
          window.scrollTo(0, 0);
        }
    
        setSearchSlide(!searchSlide);
    }
    
    const handleClearInput = () => {
        setSearchQuery('');
        document.querySelector('input[aria-label="Search"]').focus();
    };
    
    const coursePages = [
        { icon: homeIcon, label: "Home", url: "/student-dashboard/" },
        { icon: calendarsIcon, label: "Events" }
    ];

    const fetchEvents = async (params) => {
      const {selectedFilters, offset } = contentFilterData; 
      const postParams = {};

      //Item Type Filter
      if(selectedFilters?.itemType?.length > 0) {
        const itemType = selectedFilters.itemType;
        postParams.item_type = itemType;
      }
      params.page_offset      = offset;
      try {
        const allEnrolledEvents = await getEnrolledEvents(configData.access_token, params, postParams);
        if (allEnrolledEvents) {
          setIsLoading(false);
          return allEnrolledEvents;
        }
        setIsLoading(false);
        setNotFound(true);
      } catch (error) {
        setIsLoading(false);
        console.error(error);
      }

    }

    const getEnrolledEventStatus = (startDateTime, endDateTime, activities) => {
      if (new Date(startDateTime) > new Date()) {
        return 'Not Started';
      } else if (new Date(endDateTime) >= new Date()) {
        return 'Ongoing';
      } else if (new Date(endDateTime) < new Date()) {
        let eventStatus = 0, courseStatus = 0, bundleStatus = 0;
        if (activities.length > 0) {
          activities.forEach((activity) => {
            if(activity.ea_activity_type === 'session') {
              eventStatus = activity.ll_attended === 1 ? 100 : activity.ea_session_delivery_type === 'offline'  ? 100 : 0;
            } else if(activity.ea_activity_type === 'Course') {
              courseStatus = activity.cs_percentage !== null && activity.cs_percentage === 100 ? 100 : 0;
            } else if(activity.ea_activity_type === 'Bundle') {
              bundleStatus = activity.bs_percentage !== null && activity.bs_percentage === 100 ? 100 : 0;
            }
          });
          const totalStatus = (eventStatus + courseStatus + bundleStatus) / activities.length;
          if (totalStatus === 100) {
            return 'Completed';
          } else {
            return 'Incomplete';
          }
        } else {
          return 'Incomplete';
        }
      }
    }

    useEffect(() => {
      const handler = setTimeout(() => {
        setDebouncedSearch(searchQuery);
      }, 500);
      return () => clearTimeout(handler);
    }, [searchQuery]);

    useEffect(() => {
      if (abortController) {
        abortController.abort();
      }
      const newAbortController = new AbortController();
      setAbortController(newAbortController);
      const signal = newAbortController.signal;

      if (signal && !signal.aborted) {
        const loadData = async () => {
          const data = await fetchEvents({page_limit: 15, offset: 0, search: searchQuery});
          if (data) {
            setData(data);
            setEnrolledEvents(data.data);
          }
        }
        loadData();
      }
    }, [contentFilterData, debouncedSearch]);

    const eventData = enrolledEvents && enrolledEvents?.map((value) => {
      const startDateTime = value?.bce_start_date ? value?.bce_start_date.split('T')[0] + 'T' + value?.bce_start_time + 'Z' : new Date();
      const endDateTime = value?.bce_end_date ? value?.bce_end_date.split('T')[0] + 'T' + value?.bce_end_time + 'Z' : new Date();
      const isExpired   = new Date(parseISO(endDateTime)) < new Date() ? true : false;
              
      let dataMap = {
        className: isExpired ? 'expired' : '',
        eventImage: imageSrc('event', value?.bce_thumbnail, paths),
        eventType: value?.bce_type ? value.bce_type.charAt(0).toUpperCase() + value.bce_type.slice(1) : '',
        eventTitle: value?.bce_name ?? '',
        eventDeadline: value?.bce_end_date ? 'Deadline: ' + format(new Date(value.bce_end_date), 'MMM dd, yyyy' ) : '',
        eventLink: value?.bce_slug ? `/student-dashboard/events/${value.bce_slug}` : '',
        eventDefaultImg:defaultImg,
        eventStatus: getEnrolledEventStatus(startDateTime, endDateTime, value?.event_activities)
      }
      
      if (value?.bce_delivered_type === 'live' && (new Date(value?.bce_end_date) >= new Date()) && value.event_activities.length === 1) {
        dataMap.eventButton    = isExpired ? "Event expired" : "Join now"
        dataMap.eventStartLink = isExpired ? false : value.event_activities[0].live_classes.lc_session_link+'?user_token='+configData.access_token+'&auto_redirect=true'
        dataMap.linkToCopy     = isExpired ? false : value.event_activities[0].live_classes.lc_session_link+'?user_token='+configData.access_token+'&auto_redirect=true'
      } else {
        dataMap.eventButton    = "View Event details"
        dataMap.eventStartLink = value?.bce_slug ? `/student-dashboard/events/${value.bce_slug}` : ''
      }
      return dataMap;
    });
    
  return (
    <>
    {noAccess ? <Error403 /> : (
    <>
    <BreadCrumbs pages={coursePages} />
    <div className={`${className || ""} myk__stu-courses-wrapper myk__stu-events-wrapper`}>
      <Row>
        <Col md={{ span:12, order: 0 }} lg={{ span:12, order: 0 }} xl={{ span:8, order: 0 }} className="mb-md-4 mb-3">
          <div className="myk_stu-page-header">
            <h2>Events</h2>
            <div className="myk__stu-searchbar">
                <span className="icon">{searchIcon}</span>
                <FormControl 
                  placeholder="Search course by keywords" 
                  aria-label="Search" 
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  disabled={isLoading === true ? true : false}
                />
                <span className="icon-go_back" onClick={handleCourseSearchSlide}>{leftArrowLong}</span>
                <span className="icon-clear" onClick={handleClearInput}>{closeIcon}</span>
            </div>
            <div className="myk__stu-search_filter-mobile">
              <div className="myk__stu-search-wrapper">
                <span className="icon" role="button" onClick={handleCourseSearchSlide}>{searchIcon}</span>
              </div>
              <div className="myk__stu-filter-mobile" role="button" onClick={handleFilterSlide}>
                {filterIcon}
              </div>
            </div>
          </div>
          {isLoading === false && !notFound ? (
            enrolledEvents.length === 0 ? (
              <Row>
                <Col>
                  <div className="myk__stu-courseslist-empty p-0 text-center empty-block-wrapper d-flex align-items-center justify-content-center">
                    <NoItems
                      icon={noTestData}
                      title="No Events Found!"
                      description="There aren’t any events to show!"
                    />
                  </div>
                </Col>
              </Row>
            ) : (
          <>
          <Row>
            <Col>
              <div className="myk__stu-events-list">
                {eventData.map((event, index) => (
                  <CardEvent key={index} {...event} />
                ))}
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <MykPagination className="mt-4" data={data}/>
            </Col>
          </Row>
          </>
          )
          ) : (isLoading === false && notFound) ? (
          <Row>
            <Col>
              <div className="myk__stu-courseslist-empty p-0 text-center empty-block-wrapper d-flex align-items-center justify-content-center">
                <NoItems
                  icon={noTestData}
                  title="No Events Found!"
                  description="There aren’t any events to show!"
                />
              </div>
            </Col>
          </Row>
          ) : (
            <Row>
              <Col>
                <EventItemLoader items={9} />
              </Col>
            </Row>
          )}
        </Col>
        <Col md={{ span:12, order: 0 }} lg={{ span:12, order: 0 }} xl={{ span:4, order: 0 }} className="">
            {authToken && uuid && secret && idp && accountId && spuid && timezone &&
            <MyEventCalendar className="mb-4" calendarMode="month" accessToken={encode(authToken)} uuid={encode(uuid)} secret={encode(secret)} idp={encode(idp)} accountId={encode(accountId)} spuid={encode(spuid)} timeZone={encode(timezone)} language={encode(language)} />}
            <EventFilter onClickFilterSlide={handleFilterSlide}/>
        </Col>
      </Row>
    </div>
    </>
    )}
    </>
  );
}

export default Events;
